import {createApp} from 'vue'
import vue3TreeOrg from 'vue3-tree-org';
import "vue3-tree-org/lib/vue3-tree-org.css";
import App from './App.vue'
import router from './router'
import store from './store'
// import api from './api/config'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import axioses from './api/axios/axios'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Plugin from 'v-fit-columns';
import locale from "element-plus/lib/locale/lang/zh-cn";
import RightToolbar from "./components/RightToolbar";
import Pagination from "./components/Pagination";
import DictTag from "./components/DictTag";
import plugins from "./plugins";
import Vuex from "vuex"
import print from "vue3-print-nb"
import '../mock'
import '@/thirdparty/Cesium/Widgets/widgets.css'
import {addBeginAndEndTime, addDateRange, handleTree, parseTime, resetForm} from "@/utils/ruoyi";
import SinglePerson from '@/components/assembly/SinglePerson'
import MultipleDepart from '@/components/assembly/MultipleDepart'
import MultiplePost from '@/components/assembly/MultiplePost'
import ExcelImport from '@/components/assembly/func/ExeclImport.vue'
import SingleSelect from '@/components/assembly/SingleSelect'
import MultipleSelect from '@/components/assembly/MultipleSelect'
import SingleDepart from '@/components/assembly/SingleDepart'
import MultipleSelectTable from '@/components/assembly/MultipleSelectTable'
import Text from '@/components/assembly/display/text'
import OptionText from '@/components/assembly/display/optionText'
import UploadImg from '@/components/assembly/domain/uploadImg'
import MultiplePerson from '@/components/assembly/MultiplePerson'
import MultiplePersonByDepartment from '@/components/assembly/MultiplePersonByDepartment'
import Imgpop from '@/components/assembly/domain/uploadImg/imgpop'
import * as echarts from 'echarts'
import {Bar3DChart, Scatter3DChart} from 'echarts-gl/charts';
import {Grid3DComponent} from 'echarts-gl/components';
import {mixin} from '@/utils/mixin'
import htmlToPdf from '@/utils/htmlToPdf'
import '@/components/style/form.less'
// 自定义树选择组件
import TreeTable from '@/components/assembly/treeTable'
import hasPermi from "@/directive/permission/hasPermi";
import YzTable from "@/components/assembly/func/yzTable";
import YzButton0 from "@/components/assembly/func/yzButton0";
import YzButton1 from "@/components/assembly/func/yzButton1";
import YzDialog from "@/components/assembly/func/yzDialog.vue";
import YzSearchBar from "@/components/assembly/func/yzSearchBar";
import YzSearchFormItem from '@/components/assembly/func/yzSearchFormItem'
import YzManageBar from "@/components/assembly/func/yzManageBar";
import DepartmentPeople from "@/components/assembly/DepartmentPeople";
import * as jszip from 'jszip'
window.JSZip = jszip

import '@/css/global.less'
// import VueParticles from 'vue-particles'
// import
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
let app = createApp(App)
app.use(store)
    .use(router)
    .use(ElementPlus, { locale })
    .use(Plugin)
    .use(Vuex)
    .use(vue3TreeOrg)
    .use(print)
    // .use(VueParticles)
    .mount('#app');


/**
 * ruoyi 全局配置
 */

app.use(plugins)// 下载文件、弹窗、缓存等等功能
app.use(htmlToPdf)//打印pdf


//全局组件注册
app.component('DictTag', DictTag)
.component('Pagination', Pagination) //分页
.component('RightToolbar', RightToolbar)
.component('SinglePerson', SinglePerson) // 人员单选
.component('SingleDepart', SingleDepart) // 部门单选
.component('MultipleDepart', MultipleDepart) // 部门多选
.component('MultiplePost', MultiplePost) // 岗位多选
.component('SingleSelect', SingleSelect) // 通用下拉单选
.component('MultipleSelect', MultipleSelect) // 通用下拉单选
.component('MultipleSelectTable', MultipleSelectTable) // 多选表格
.component("OmitText", Text) // 表格省略文本
.component('OptionText', OptionText) // 表格 单选文本
.component('UploadImg', UploadImg)
.component('Imgpop', Imgpop)
.component('MultiplePerson', MultiplePerson)
.component('MultiplePersonByDepartment', MultiplePersonByDepartment)
.component('TreeTable', TreeTable)
.component("YzTable", YzTable)
.component("YzButton1", YzButton1)
.component("YzButton0", YzButton0)
.component("YzDialog", YzDialog)
.component('YzSearchBar', YzSearchBar)
.component('YzSearchFormItem', YzSearchFormItem)
.component('YzManageBar', YzManageBar)
.component('DepartmentPeople', DepartmentPeople)
.component('ExcelImport',ExcelImport)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

echarts.use([Scatter3DChart, Grid3DComponent, Bar3DChart]);
app.config.globalProperties.echarts = echarts
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.addBeginAndEndTime = addBeginAndEndTime
// app.config.globalProperties.getDictDatas = getDictDatas
// app.config.globalProperties.getDictDatas2 = getDictDatas2
// app.config.globalProperties.getDictDataLabel = getDictDataLabel
// app.config.globalProperties.DICT_TYPE = DICT_TYPE
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.$axioses = axioses


app.mixin(mixin)


app.directive('hasPermi', hasPermi)
